import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["blockSize", "inlineSize", "borderRadius"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const shimmer = keyframes(["0%{transform:translateX(-100%);}50%{transform:translateX(0%);}100%{transform:translateX(100%);}"]);
const ShimmerDiv = styled.div.withConfig({
  displayName: "LoadingSkeletonElementV2__ShimmerDiv",
  componentId: "sc-17vh2cq-0"
})(["position:relative;overflow:hidden;background-color:", ";", " &::after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;background-image:linear-gradient( 90deg,rgba(255,255,255,0) 0,rgba(255,255,255,0.4) 20%,rgba(255,255,255,0.7) 70%,rgba(255,255,255,0) );animation:", " 5s linear infinite;animation-delay:0.5s;@media (prefers-reduced-motion){animation-duration:0.001s !important;animation-iteration-count:1 !important;transition-duration:0.001s !important;}}"], ({
  theme
}) => theme.color['fill-primary-disabled'], ({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
}, shimmer);
const LoadingSkeletonElement = _ref => {
  let {
      blockSize,
      inlineSize,
      borderRadius
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const cssStyles = useMapTokenPropsToCSS(Object.assign({
    marginBlock: '200'
  }, rest, {
    borderRadius,
    blockSize,
    inlineSize
  }));

  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(ShimmerDiv, {
    $cssStyles: cssStyles
  });
};
export default LoadingSkeletonElement;